'use client'

import { Pagination } from 'react-instantsearch'

import { useMediaQuery } from '@/hooks/useMediaQuery'

export function CollectionPagination() {
  // react-instantsearch defaults to padding=3 (current page ±3 = up to 7 buttons),
  // which overflows the viewport on mobile. Show a smaller window of pages: ~3 on
  // mobile, ~5 on larger screens. undefined (SSR/first render) falls back to mobile.
  const isDesktop = useMediaQuery('(min-width: 640px)')

  return (
    <div className="py-8 sm:pb-12">
      {/* Pagination component from Algolia. First/last buttons jump to page 1 / the
          last page (Algolia knows the total page count). */}
      <Pagination
        padding={isDesktop ? 2 : 1}
        // Jump to the top of the collection listing (below the sticky header) instead of
        // the very top of the page, so changing page doesn't force a long scroll back down.
        onClick={() => document.getElementById('collection-products')?.scrollIntoView()}
        classNames={{
          root: 'flex justify-center items-center',
          noRefinementRoot: 'opacity-50 pointer-events-none',
          list: 'flex items-center gap-1 sm:gap-2',
          item: 'size-10 sm:size-[48px] flex items-center justify-center border border-gray-200 rounded-full text-sm font-medium transition-colors duration-200',
          firstPageItem: '',
          previousPageItem: '',
          pageItem: 'hover:bg-gray-50 text-gray-700',
          selectedItem: 'border-primary-500 bg-primary-500 text-white hover:bg-primary-600',
          disabledItem: 'text-gray-400 bg-gray-50 cursor-not-allowed border-gray-200',
          nextPageItem: '',
          lastPageItem: '',
          link: 'w-full h-full flex items-center justify-center px-3 py-2',
        }}
      />
    </div>
  )
}
